<template>
    <!-- V12 -->
    <div class="financing-available clearfix">
            <a class="v12-learn-more track-GA4-event row" data-ga4_name="financing_prequalify" :data-ga4_model_category="Product.GA_Category" :data-ga4_model_name="Product.Product.Name" data-ga4_click_text="prequalify now" data-toggle="modal" data-target="#ModalV12" v-on:click="initiateV12Slider()" style="cursor:pointer;">
                <div class="col-md-8 col-xs-6">
                    {{V12Label}}
                </div>
                <div class="col-md-4 col-xs-6 text-right"><img :src="cdn + '/Images/Shared/Icons/icon_v12_transparent.png'" /></div>
            </a>
    </div>
    <div class="modal" tabindex="-1" role="dialog" id="ModalV12">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <img :src="cdn + '/Images/Shared/Icons/icon_v12_transparent.png'" />
                </div>

                <div class="modal-body">
                    <div class="v12-calculator">
                        <div class="row text-left" style="padding-top:20px;">
                            <div class="col-md-7">
                                <span style="font-weight: bold;">Choose your deposit:</span><br />
                                <span style="text-transform:none;font-size:12px;color:#999;">deposit will be taken after acceptance by V12 finance</span>
                            </div>
                            <div class="col-md-5">
                                <input type="number" style="width: 100px; padding: 10px; border: 1px solid #ddd; -moz-appearance: textfield;" v-model="SliderValue" :min="MinDeposit" :max="MaxDeposit" @keyup="ValidateInputValue" />
                            </div>
                        </div>
                        <div class="v12-slider" style="margin:20px;">
                            <Slider v-model="SliderValue" :min="MinDeposit" :max="MaxDeposit" :format="format" @update="CalculateV12()" />
                        </div>
                        <div class="row v12-terms">
                            <div class="col-md-12">
                                <label>Choose a term:</label>
                            </div>
                            <div class="col-md-12">
                                <div class="term row" v-for="item in Calculated" :key="item.productId" style="text-align:left;margin-left:10px;height:auto;">
                                    <label :for="'OrderV12ProductId' + item.productId">
                                        <input type="radio" name="Order.OrderV12ProductId" :id="'OrderV12ProductId' + item.productId" :value="item.productId" v-model="Selected" v-on:change="SelectTerm" style="margin-right:10px;" />
                                        {{item.months}} months - {{item.apr}}% APR: <strong>&pound;{{Monthlypayment(item)}}</strong> per month<span v-show="item.monthsDeferred > 0"> - first payment in {{item.monthsDeferred}} months!</span>
                                    </label>
                                    <div class="row" style="padding:0 25px 25px 45px; text-align:left;line-height:2rem;color:#888;" v-show="item.productId == Selected">
                                        <span id="lblCashPrice">Total cash price: &pound;{{item.cashPrice}}.</span><br />
                                        <span id="lblDeposit">&pound;{{item.deposit}} deposit.</span><br />
                                        <span id="lblAmountCredit">Amount of credit: &pound;{{item.loanAmount}}.</span><br />
                                        <span id="lblRepayable">
                                            <span v-if="item.monthsDeferred > 0">Non-payment period {{item.monthsDeferred}} months, followed by</span>
                                            <span v-else>Repayable by </span>
                                            <span v-if="item.initialPayments != item.finalPayment && item.finalPayment > 0">
                                                {{item.months - 1}} monthly repayments of &pound;{{item.initialPayments}} and a final payment of &pound;{{item.finalPayment}}.
                                            </span>
                                            <span v-else>
                                                {{item.months}} monthly repayments of &pound;{{item.initialPayments}}.
                                            </span>
                                        </span>
                                        <span id="lblApr">
                                            Representative APR {{item.apr}}%.
                                        </span>
                                        <span id="lblAnnualRate">Annual rate of interest {{item.annualRate}}% fixed.</span>
                                        <span id="lblArrangementFee" v-show="item.documentFee > 0">Arrangement fee &pound;{{item.documentFee}}.</span>
                                        <span id="lblSettlementFee" v-show="item.settlementFee > 0">Settlement fee &pound;{{item.settlementFee}}.</span>
                                        <span id="lblTotalRepayable">Total amount repayable &pound;{{item.amountPayable}} including total interest of &pound;{{item.interest}}.</span>
                                        <span id="lblBnpl" v-show="item.monthsDeferred > 0 && item.name.indexOf('Buy Now Pay Later') >= 0">
                                            Buy Now Pay Later Option: If you pay the amount of credit plus the settlement fee of &pound;{{item.settlementFee}} by the end of the non-payment period, you will pay no interest. If you have not paid the amount of credit in full before the end of the non-payment period the &pound;{{item.settlementFee}} fee will not be payable but interest (at the rate specified above) will be charged on the outstanding credit amount, from the date we told you your agreement was live.'
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer row-fluid">
                    <div class="col-md-10 text-left" style="font-size:10px;">
                        {{getInterfaceText('v12_disclaimer')}}
                    </div>
                    <div class="col-md-2">
                        <button type="button" class="btn btn-default" data-dismiss="modal">{{getInterfaceText('close')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import generalMixin from '../mixins/general.js';
    import Slider from '@vueform/slider'; //https://github.com/vueform/slider
    export default {
        name: 'V12',
        props: ['Amount', 'V12FinanceProducts', 'V12Label', 'Product'],
        mixins: [generalMixin],
        components: {
            Slider
        },
        data: function () {
            return {
                value: 1,
                format: {
                    prefix: '&pound;'
                },
                cdn: window.cdn,
                SliderValue: 0,
                DepositValue: 250,
                MaxDeposit: 1000,
                MinDeposit: 0,
                Selected: [],
                Calculated: []
            }
        },
        methods: {
            initiateV12Slider() {
                this.SliderValue = this.Product.V12DefaultMaxDeposit;
                //this.SliderValue = Math.round(this.Amount * 0.2);
                this.Selected = this.V12FinanceProducts[0].ProductId;
                this.CalculateV12(true);
                this.SelectTerm();
                //this.CalculateV12(); //Eerst bepalen welk product te gebruiken, daarop volgend de max deposit bepalen om vervolgens opnieuw het maandbedrag te berekenen.
            },
            CalculateV12(initiate) {
                if (window != undefined && window.V12 != undefined) {
                    this.Calculated = [];
                    for (var i = 0; i < this.V12FinanceProducts.length; i++) {
                        var prod = window.V12.getFinanceProduct(this.V12FinanceProducts[i].ProductId);
                        var temp = window.V12.calculate(prod, this.Amount, this.SliderValue);
                        this.Calculated.push(temp);
                        console.log(this.Calculated);

                        if (initiate != undefined && initiate == true && this.FinanceProduct.months < prod.months) {
                            this.Selected = prod.productId;
                        }
                    }
                }
            },
            Monthlypayment(product) {
                var temp = this.V12FinanceProducts.filter(function (x) { return x.ProductId == product.productId })[0];
                return parseFloat((this.Amount - this.SliderValue) * temp.CalculationFactor).toFixed(2);
            },
            SelectTerm() {
                this.MaxDeposit = Math.floor(this.Amount - this.FinanceProduct.minLoan);
                if (this.MaxDeposit > (this.Amount * 0.5)) {
                    this.MaxDeposit = Math.floor(this.Amount * 0.5); //deposit >= MinLoan en <= 50% van het totaal (zie mail Tom)
                }
                if (this.MaxDeposit < this.SliderValue) {
                    this.SliderValue = this.MaxDeposit;
                    this.CalculateV12();
                }
                //this.MinDeposit = this.FinanceProduct.minLoan; min deposit mag altijd 0 zijn
            },
            ValidateInputValue() {
                if (this.SliderValue > this.MaxDeposit) {
                    this.SliderValue = this.MaxDeposit;
                } else if (this.SliderValue < this.MinDeposit) {
                    this.SliderValue = this.MinDeposit;
                }
            }
        },
        computed: {
            Ceiling() {
                var result = Math.round(this.Amount * 0.5) - 1;
                //min loan amount = 1000. Change ceil when ceil amount is > then min loan amount
                if ((this.Amount - 1000) < result) {
                    result = Math.round(this.Amount - 1000);
                }

                return result;
            },
            Floor() {
                return Math.round(this.Amount * 0.1);
            },
            FinanceProduct() {
                return window != undefined && window.V12 != undefined ? window.V12.getFinanceProduct(this.Selected) : null;
            },
        },
        created() {
            let v12Script = document.createElement('script')
            v12Script.setAttribute('src', 'https://apply.v12finance.com/JavascriptGateway/JSCalc/CalculatorScript?retailerId=' + document.getElementById('vue-parameters').dataset.v12retailid + '&retailerGuid=' + document.getElementById('vue-parameters').dataset.v12retailguid)
            document.body.appendChild(v12Script)
            this.interfaceTexts = JSON.parse(document.getElementById('vue-parameters').dataset.interfacetexts);
        },
    }
</script>
